import styled from 'styled-components';

import Button from 'components/shared/Button';
import StandardModal, { Actions } from 'components/shared/StandardModal';
import { BodySmall } from 'styles/typography';

type Props = {
  flagTitle: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function DisableFlagModal({ flagTitle, loading, onConfirm, onCancel }: Props) {
  return (
    <StandardModal title='Disable Feature Flag' onCancel={onCancel}>
      <Content>
        <BodySmall>
          <strong>Disable {flagTitle} for everyone?</strong> This will disable the feature for all users.
        </BodySmall>
        <Actions>
          <Button variant='ghost' onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={loading} variant='danger'>
            {loading ? 'Disabling...' : 'Disable for Everyone'}
          </Button>
        </Actions>
      </Content>
    </StandardModal>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
